<div class="form-group" [formGroup]="formGroup" *ngIf="formGroup">
    <input type="hidden" [id]="controlName" [formControlName]="controlName" />

    <label [for]="controlName" class="form-control-label">
        {{ label ?? 'Campo sem label definida' }}
        <span class="text-danger" *ngIf="isRequired && !readOnly">*</span>
        <sume-help-tooltip
            *ngIf="helpMessage"
            [message]="helpMessage"
            size="small">
        </sume-help-tooltip>
    </label>

    <input
        *ngIf="!readOnly"
        type="text"
        class="form-control"
        [formControl]="searchControl"
        [ngbTypeahead]="search"
        (focus)="focus$.next($any($event).target.value)"
        (click)="click$.next($any($event).target.value)"
        (keydown)="onKeydown($event)"
        #instance="ngbTypeahead"
        [ngClass]="{
            'is-invalid':
                formControl?.invalid &&
                (formControl?.dirty || formControl?.touched || changeText)
        }"
        (selectItem)="onItemSelected($event.item)"
        (blur)="onBlurClear()"
        [placeholder]="searchControl.disabled ? '' : 'Digite para buscar...'" />

    <input
        *ngIf="readOnly"
        type="text"
        class="form-control"
        [formControl]="searchControl"
        readonly />

    <div
        class="invalid-feedback"
        *ngIf="!readOnly && formControl?.errors?.required">
        Este campo é obrigatório
    </div>
    <div
        class="invalid-feedback"
        *ngIf="
            !readOnly && formControl?.errors && !formControl?.errors?.required
        ">
        Campo inválido
    </div>

    <div class="text-danger small mt-1" *ngIf="!formControl">
        <i class="fas fa-exclamation-triangle"></i>
        FormControl '{{ controlName }}' não encontrado no FormGroup
    </div>
</div>
